import { apiClient } from './apiClient';
const BASE_PATH = '/api/v1/shipments';
/**
 * Upload a single document to a shipment
 */
export const uploadShipmentDocument = async (shipmentId, file, documentType) => {
    const formData = new FormData();
    formData.append('files', file); // Backend expects 'files' field name
    formData.append('documentType', documentType);
    // Debug logging
    console.log('Uploading document:', {
        shipmentId,
        fileName: file.name,
        fileSize: file.size,
        documentType,
    });
    const response = await apiClient.post(`${BASE_PATH}/${shipmentId}/documents`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    // Backend returns an array of documents, return the first one for single upload
    const documents = response.data.data;
    return Array.isArray(documents) ? documents[0] : documents;
};
/**
 * Upload multiple documents to a shipment
 */
export const uploadShipmentDocuments = async (shipmentId, files, documentType) => {
    const formData = new FormData();
    // Append each file with the same field name to create an array
    files.forEach(file => {
        formData.append('files', file);
    });
    formData.append('documentType', documentType);
    // Debug logging
    console.log('Uploading documents:', {
        shipmentId,
        fileCount: files.length,
        fileNames: files.map(f => f.name),
        totalSize: files.reduce((sum, f) => sum + f.size, 0),
        documentType,
    });
    const response = await apiClient.post(`${BASE_PATH}/${shipmentId}/documents`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data.data;
};
/**
 * Upload multiple files with different document types
 */
export const uploadShipmentDocumentsWithTypes = async (shipmentId, filesWithTypes) => {
    const formData = new FormData();
    // Append each file
    filesWithTypes.forEach(({ file }, index) => {
        formData.append('files', file);
        formData.append(`documentType_${index}`, filesWithTypes[index].documentType);
    });
    // Debug logging
    console.log('Uploading documents with types:', {
        shipmentId,
        fileCount: filesWithTypes.length,
        files: filesWithTypes.map(({ file, documentType }) => ({
            name: file.name,
            size: file.size,
            documentType,
        })),
    });
    const response = await apiClient.post(`${BASE_PATH}/${shipmentId}/documents`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data.data;
};
